import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useFeatureHidden } from '@/components/feature-gate'
import {
  ACCOUNTING_PROVIDERS,
  useAccountingIntegrationFeature,
  type AccountingProvider,
} from '@/services/api/integrations/accountingProviders'

/**
 * Route guard for integration screens. When the Space's plan hides the
 * integration (Basic), a direct URL lands on the Dashboard instead of a blank
 * or locked page. `provider` narrows it to one provider's screens; without it
 * any accounting provider keeps the shared screens (mapping, Bank Feed) open.
 */
export default function IntegrationRoute({
  provider,
  children,
}: {
  provider?: AccountingProvider
  children: ReactNode
}) {
  const { hidden: allHidden } = useAccountingIntegrationFeature()
  const providerHidden = useFeatureHidden(
    ACCOUNTING_PROVIDERS[provider ?? 'xero'].feature,
  )
  const hidden = provider ? providerHidden : allHidden

  if (hidden) return <Navigate to="/" replace />

  return <>{children}</>
}
